/**
 * @author HungNS
 */
import IndexService from './IndexService'

export default class FactoryService {
    static getService(serviceName) {
        let RequestService = IndexService[serviceName]
        if (!RequestService) {
            throw new Error('Invalid request service name: ' + serviceName)
        }
        return new RequestService();
    }
}